import React from "react";
import { Button } from "react-bootstrap";
import { Add } from "@mui/icons-material";
import { MecordColors } from "Constants/Color";

interface AddButtonProps {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  height?: string;
  width?: string;
  minWidth?: string;
  className?: string;
  variant?: string;
  type?: "button" | "submit" | "reset";
  fullWidth?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({
  onClick,
  label = "Add",
  disabled = false,
  height = "44px",
  width,
  minWidth,
  className = "",
  variant = "primary",
  type = "button",
  fullWidth = false,
}) => {
  const baseStyle: React.CSSProperties = {
    backgroundColor: MecordColors.PrimaryButtonBGColor,
    borderColor: MecordColors.PrimaryButtonBGColor,
    borderRadius: "8px",
    height: height,
    color: MecordColors.PrimaryButtonTextColor,
    fontSize: "14px",
    padding: "8px 10px",
    ...(width && { width }),
    ...(minWidth && { minWidth }),
  };

  const handleMouseOver = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      e.currentTarget.style.backgroundColor =
        MecordColors.PrimaryButtonHoverBGColor;
      e.currentTarget.style.borderColor =
        MecordColors.PrimaryButtonHoverBGColor;
    }
  };

  const handleMouseOut = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      e.currentTarget.style.backgroundColor = MecordColors.PrimaryButtonBGColor;
      e.currentTarget.style.borderColor = MecordColors.PrimaryButtonBGColor;
    }
  };

  return (
    <Button
      variant={variant}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`d-flex align-items-center justify-content-center gap-2 ${className} ${
        fullWidth ? "w-100" : ""
      }`}
      style={baseStyle}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <Add fontSize="small" />
      {label}
    </Button>
  );
};

export default AddButton;
